import OrderAction from './orderAction';

export default class AnonymizeAction extends OrderAction {
    static NAME = 'anonymize';

    static is_available({ items, mode }) {
        return ((Array.isArray(items) && items.length === 1) || !Array.isArray(items)) && mode === 'detail';
    }

    // only simple
    get needs_confirm() {
        return (Array.isArray(this.items) && this.items.length === 1) || !Array.isArray(this.items);
    }

    get warning_confirm() {
        return true;
    }

    get needs_selection() {
        return false;
    }

    onActionDone() {
        if ((Array.isArray(this.items) && this.items.length === 1) || !Array.isArray(this.items)) {
            if (!this.async) {
                this.sync();
            }
            this.onClose();
        }
    }
}
